import { Button } from 'admin/components/atoms/Buttons';
import AdminUser from 'admin/models/admin_user';
import { components } from 'admin/schema/docs/api/admin';
import React from 'react';

// topup_by_seven_bank_atm_description の全言語分。説明文は取引時の言語設定で決まるため、
// 日本語だけで判定するとキャンセル不可のはずのチャージでボタンが出る (zh/ko は en にフォールバック)
const SEVEN_ELEVEN_TRANSACTION_DESCRIPTIONS = [
  'セブン銀行ATMによるチャージ',
  'topup by Seven Bank ATM',
];

type Transaction = components['schemas']['TransactionDetail'];

type Props = {
  transaction: Transaction;
  onClick: () => void;
  user: AdminUser;
  disabled?: boolean;
};

const isCancelable = (transaction: Transaction, user: AdminUser) => {
  if (transaction.is_modified) return false;
  if (!user.isAllowedTo('edit', 'transaction', transaction)) return false;
  if (
    transaction.rows?.some(
      (row) => row.description && SEVEN_ELEVEN_TRANSACTION_DESCRIPTIONS.includes(row.description)
    )
  )
    return false;
  // サーバが 422 can_not_refund_paytree_gw_transaction で拒否するため、押しても必ず失敗する
  if (transaction.payment_method_type === 'paytree-gw') return false;
  if (transaction.type === 'exchange_inflow' || transaction.type === 'exchange_outflow')
    return false;
  return true;
};

const CancelButton = ({ transaction, onClick, user, disabled }: Props) => {
  if (!isCancelable(transaction, user)) return null;

  return (
    <span>
      <Button variant="danger" onClick={onClick} disabled={disabled}>
        取引をキャンセル
      </Button>
    </span>
  );
};

export default CancelButton;
